import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.event.search;
const baseData = createSelector([baseState], state => state.data);

export const eventsSearchFilters = createSelector([baseState], (state) => {
    return state.filters;
});

export const eventsSearchData = createSelector([baseData], (data) => {
    return {
        favorite: Object.values(data.favorite),
        old: Object.values(data.old),
        events: Object.values(data.events).sort((a, b) => a.index - b.index)
    }
});

export const eventsSearchCurrentPage = createSelector([baseState], (state) => {
    return state.current_page;
});
export const eventsSearchLoading = createSelector([baseState, eventsSearchCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING && page === 1
});
export const eventsSearchHasNext = createSelector([baseState], (state) => {
    return !!state.metadata.hasNext;
});
export const eventsSearchNextLoading = createSelector([baseState, eventsSearchCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING  && page !== 1
});
export const eventsSearchErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});